import {useListView} from '../../core/ListViewProvider'
import {ListToolbar} from './ListToolbar'
import {ListSearchComponent} from './ListSearchComponent'

const ListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header'>
      <div className='card-title d-flex align-items-center position-relative me-4 '>
        <div className='d-flex flex-column'>
          <div className='d-flex align-items-center'>
            <h5 className='text-black fs-4 fw-semibold '>Multiple IVR Management</h5>
          </div>
          <div className='d-flex flex-wrap fs-6'>
            <p className='text-gray-500 mb-0 fw-normal' style={{fontSize: '12px'}}>
              Manage Customer IVR Numbers
            </p>
          </div>
        </div>
      </div>

      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        <ListSearchComponent />
        {/* begin::Group actions */}
        {selected.length > 0 ? <div></div> : <ListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {ListHeader}

